import type { Register } from 'src/register'
import { api, consts } from 'src/plugins'
import apiServers from './plugins/api'
import constsServers from './plugins/consts'
import dynamicJs from './plugins/dynamicJs'
import * as customPages from './modules/custom'
import { appStore, dynamicJsStore, pageStore } from 'src/stores'
import { mainStore } from './stores'

const register = (): Register => {
  document.getElementsByTagName('title')[0].innerText = 'ENAS'
  document.querySelector("link[rel*='icon']")?.setAttribute('href', require('./assets/favicon.ico'))

  api.register(apiServers)
  consts.register(constsServers)
  appStore.register(mainStore)
  dynamicJsStore.register(dynamicJs)
  pageStore.register(customPages)

  return {
    routes: require('./routes').default,
    beforeMounted: () => Promise.all([mainStore.willMount()]),
  }
}

export default register